<template>
  <div
    class="layout"
    :class="[computedCharacterColorClass]"
  >
    <!-- 梵字・家紋 + 俗名の表記（ラベル） + 俗名 -->
    <div
      class="main"
      :class="{
        adjust: isBackSymbolAvailable,
      }"
    >
      <!-- 梵字・家紋 -->
      <div>
        <div
          v-if="isBackSymbolAvailable"
          class="symbol flex center"
        >
          <div class="box">
            <ImageResolver
              :src="computedBackSymbolSrc"
              class="character"
            />
          </div>
        </div>
      </div>

      <!-- スペーサー -->
      <div />

      <!-- 享年表記 + 没年齢 + 没年齢単位 -->
      <div class="ageAtDeaths">
        <div class="ageAtDeath flex center column">
          <!-- 享年表記 -->
          <TabletCharacterImage
            v-for="(character, index) in columns[0].ageAtDeathPrefix"
            :key="`deathMonth-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...ageAtDeathPrefixPayload,
              characterIndex: index,
              columnIndex: 0,
              ...$event,
            })"
          />

          <!-- 没年齢 -->
          <TabletCharacterImage
            v-for="(character, index) in columns[0].ageAtDeath"
            :key="`deathDay-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...ageAtDeathPayload,
              characterIndex: index,
              columnIndex: 0,
              ...$event,
            })"
          />

          <!-- 没年齢単位 -->
          <TabletCharacterImage
            v-for="(character, index) in columns[0].ageUnitCharacter"
            :key="`diedCharacter-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...ageUnitCharacterPayload,
              characterIndex: index,
              columnIndex: 0,
              ...$event
            })"
          />
        </div>
      </div>

      <!-- スペーサー -->
      <div />
    </div>

    <!-- 右側: 没年 -->
    <div class="side">
      <div class="dates">
        <!-- 右側: 没年 -->
        <div class="date right flex align-center column">
          <div class="box grow" />
          <div class="box flex column">
            <!-- 没年 -->
            <TabletCharacterImage
              v-for="(character, index) in columns[0].dateOfDeathYear"
              :key="`deathYear-${character.character}-${index}`"
              :char="character"
              :font="typography.font"
              :size="computedSideRightCharacterSize"
              @onClickCharacter="onClickCharacter({
                ...dateOfDeathYearPayload,
                characterIndex: index,
                columnIndex: 0,
                ...$event,
              })"
            />

            <!-- 没月 -->
            <TabletCharacterImage
              v-for="(character, index) in columns[0].dateOfDeathMonth"
              :key="`deathMonth-${character.character}-${index}`"
              :char="character"
              :font="typography.font"
              :size="computedSideRightCharacterSize"
              @onClickCharacter="onClickCharacter({
                ...dateOfDeathMonthPayload,
                characterIndex: index,
                columnIndex: 0,
                ...$event,
              })"
            />

            <!-- 没日 -->
            <TabletCharacterImage
              v-for="(character, index) in columns[0].dateOfDeathDay"
              :key="`deathDay-${character.character}-${index}`"
              :char="character"
              :font="typography.font"
              :size="computedSideRightCharacterSize"
              @onClickCharacter="onClickCharacter({
                ...dateOfDeathDayPayload,
                characterIndex: index,
                columnIndex: 0,
                ...$event,
              })"
            />

            <!-- 没表記 -->
            <TabletCharacterImage
              v-for="(character, index) in diedCharacter"
              :key="`diedCharacter-${character.character}-${index}`"
              :char="character"
              :font="typography.font"
              :size="computedSideRightCharacterSize"
              @onClickCharacter="onClickCharacter({
                ...diedCharacterPayload,
                characterIndex: index,
                columnIndex: null,
                ...$event,
              })"
            />
          </div>
          <div class="box grow" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabletPreviewMixin from "@/mixins/tabletPreview.mixin";

export default {
  mixins: [
    TabletPreviewMixin.back,
    TabletPreviewMixin.character,
  ],
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
    // 享年表記 + 没年齢 + 没年齢単位
    // の文字列の長さから要素一つあたりのサイズを算出
    computedCharacterSize () {
      const {
        ageAtDeathPrefix,
        ageAtDeath,
        ageUnitCharacter,
      } = this.columns[0];

      const defaultSize = 25;
      const maxHeight = 320;

      const ageUnitCharacterLength = ageUnitCharacter ? ageUnitCharacter.length : 0;
      const characterLength = ageAtDeathPrefix.length + ageAtDeath.length + ageUnitCharacterLength;
      const characterSize = maxHeight / characterLength;
      const size = Math.min(defaultSize, characterSize);

      return size;
    },

    // 没年月日 + 没表記
    // の文字列の長さから要素一つあたりのサイズを算出
    computedSideRightCharacterSize () {
      const { diedCharacter } = this;
      const {
        dateOfDeathYear,
        dateOfDeathMonth,
        dateOfDeathDay,
      } = this.columns[0];

      const defaultSize = 20;
      const maxHeight = 400 - 15 - 15; // padding の上下分

      const characterLength = dateOfDeathYear.length + dateOfDeathMonth.length + dateOfDeathDay.length + diedCharacter.length;
      const characterSize = maxHeight / characterLength;
      const size = Math.min(defaultSize, characterSize);

      return size;
    },
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-front.scss";

.layout {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  .main {
    display: grid;
    grid-template-rows: 80px 1fr auto 1fr;
    grid-template-columns: 1fr;
    height: 100%;
    width: 50px;
    position: absolute;
    top: 0;
    left: -50px;
    box-sizing: border-box;
    overflow-x: visible;
    z-index: 1;

    &.adjust {
      padding-bottom: 15px; // (80 - 50) / 2
    }

    @include symbol(100px); // (150 + 50) / 2

    .ageAtDeaths {
      height: 100%;
      width: 100%;
      position: relative;
      box-sizing: border-box;

      .ageAtDeath {
        height: 100%;
        transform: translateX(100px);

        @include character(25px);
      }
    }

    .secularNamePrefixes {
      padding-top: 15px;

      &.adjust {
        padding-bottom: 15px;
      }
    }
  }

  .side {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr;
    height: 100%;
    position: relative;
    box-sizing: border-box;

    .dates {
      height: 100%;
      width: 100%;
      position: relative;

      .date {
        height: 100%;
        width: 50px;
        padding: 15px 0;
        box-sizing: border-box;

        &.left {
          float: left;
        }

        &.right {
          float: right;
          transform: translateX(0px);
        }

        @include character(20px);
      }
    }
  }
}
</style>
